<template>
  <div class="home_box">
    <van-cell-group>
      <van-field v-model="registerForm.name" label="姓名" placeholder="请输入用户名" />
      <van-field v-model="registerForm.gender" label="性别" placeholder="请输入性别" />
      <van-field v-model="registerForm.age" label="年龄" placeholder="请输入年龄" />
      <van-field v-model="registerForm.city" label="所在城市" placeholder="请输入所在城市" />
      <van-field v-model="registerForm.job" label="从事行业" placeholder="请输入从业行业" />
      <van-field v-model="registerForm.work_mode" label="工作方式" placeholder="请输入工作方式" />
      <van-field v-model="registerForm.mobile" label="联系电话" placeholder="请输入联系电话" />
      <van-field v-model="registerForm.email" label="邮箱" placeholder="请输入邮箱" />
      <van-field
        v-model="registerForm.resource"
        label="资源简介"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入资源简介"
      />
      <van-field
        v-model="registerForm.exp"
        label="经验简介"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入经验简介"
      />
    </van-cell-group>
    <div class="confirm">
      <div class="sp_btn">提交申请</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registerForm: {
        name: "",
        gender: "",
        age: "",
        city: "",
        job: "",
        work_mode: "",
        mobile: "",
        email: "",
        resource: "",
        exp: ""
      }
    };
  }
};
</script>

<style lang="less" scoped>
.home_box {
  position: relative;
  padding-bottom: 50px;
  .confirm {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    .sp_btn {
      width: 120px;
      text-align: center;
      margin: 0 auto;
      padding: 10px 15px;
      color: #666;
      letter-spacing: 1.5px;
      border-radius: 90px;
      box-shadow: 1.2px 1.2px 5px -3px rgba(0, 0, 0, 0.6),
        -0.1px -0.1px 5px -3px rgba(0, 0, 0, 0.1);
    }
    .sp_btn:hover {
      box-shadow: inset 1.2px 1.2px 5px -3px rgba(0, 0, 0, 0.4);
      text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>